import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { templateSelector } from "../../../redux/templateSlice";

const FieldFooter = ({ createTemplate, cancelHandler, disabled }) => {
  const template = useSelector(templateSelector);
  return (
    <>
      <div className="field-footer py-3">
        <button
          className="btn cta-primary-light"
          onClick={() => cancelHandler()}
        >
          Cancel
        </button>
        <button
          className="btn cta-primary"
          disabled={disabled}
          onClick={() => createTemplate()}
        >
          {template.id ? "Update" : "Create"}
        </button>
      </div>
    </>
  );
};

export default FieldFooter;
